<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <h3 style="font-size: 1.1vw !important">تعاریف پایه / {{ name_route }}</h3>
        <hr>
        <div class="row   justify-content-center">
          <div class="col-lg-3 mb-3">
            <label class="form-label"> عنوان {{ name_route2 }}</label>
            <input v-model="name" class="form-control" type="text" name=""
            >

          </div>
          <div class="col-lg-2 mb-3">
            <label class="form-label"> ضریب اهمیت {{ name_route2 }}</label>
            <input v-model="factor" class="form-control" type="text" name=""
            >

          </div>
          <div class="col-lg-2 mb-3">
            <button @click.prevent="store" v-if="!is_update" style="width: 6vw !important; transform: translateY(1.7vw)"
                    class="btn btn-primary btn-submit-1">افزودن
            </button>
            <button @click.prevent="update(item_id)" v-if="is_update" style="width: 6vw !important; transform: translateY(1.7vw)"
                    class="btn btn-primary btn-submit-1">ویرایش
            </button>
            <Reset @click.prevent="resetForm" v-if="is_update" style="width: 2vw; height: 2vw; transform: translateX(-2vw)"/>
          </div>
        </div>
        <hr class="mb-2 mt-2">
        <center v-if="allItems.length">
          <table style="width: 48vw;" class="table table-striped" >
            <tbody>
            <tr>

              <th style="width: 1vw;">ردیف</th>
              <th>عنوان {{name_route2}}</th>
              <th style="width: 11vw;">ضریب اهمیت {{name_route2}}</th>
              <th style="width: 3vw;">عملیات</th>

            </tr>
            <tr v-for="(item,index) in allItems">
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.factor}}</td>
              <td>
                <div class="d-flex">
                  <a @click.prevent="edit(item['id'], item.name , item.factor)" href="#"><img class="table-edit-img"
                                                                                              src="../../assets/img/pen.svg" alt="edit"></a>
                  &nbsp;
                  <a @click.prevent="deleteItem(item['id'])" href="#"><img class="table-delete-img mr-1"
                                                                           src="../../assets/img/delete.svg"
                                                                           alt="delete"></a>
                </div>
              </td>
            </tr>


            </tbody>
          </table>
        </center>
        <center v-else>
          {{name_route}} یافت نشد
        </center>


      <div class="d-flex justify-content-between p-3">
        <button @click.prevent="backPage" class="btn btn-submit-1 btn-primary" style="width: 4vw !important;">قبلی
        </button>
        <button @click.prevent="nextPage" class="btn btn-submit-1 btn-primary" style="width: 4vw !important;">بعدی
        </button>
      </div>
    </div>
    </div>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 28%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import {useToast} from "vue-toastification";
import login from "@/views/auth/Login.vue";

const toast = useToast();

export default {
  name: 'HomeView',
  data() {
    return {
      deleteModal: false,
      is_update: false,
      name_route: '',
      counter: 1,
      allItems: [],
      item_id: '',
      name: '',
      factor: '',
      name_route2: '',
    }
  },
  components: {
    Reset,
    Sidebar,
    splash
  },
  methods: {
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var url = new URL(`${this.base_url}/BasicDefinitionsFiveF/destroy/${id}`);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message){
              toast.success(response.message)
              this.all()
              this.resetForm()
            }
          })
          .catch(error => console.error('Error:', error));
    },
    store() {
      if (!this.name.length){
        toast.error('عنوان اجباری است!')
        return;
      }
     else if (!this.factor.length){
        toast.error('ضریب اهمیت اجباری است!')
       return;
      }
      fetch(`${this.base_url}/BasicDefinitionsFiveF/store`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'name': this.name,
          'type': this.counter,
          'factor': this.factor,


        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response['error']) {

              toast.error(response.error)
              return
            }
            toast.success(response.message)


            this.all()
            this.resetForm()


          }).catch((err) => {
      })
    },
    edit(id, name, factor) {
      this.item_id = id
      this.name = name
      this.factor = factor
      this.is_update = true
    },
    deleteItem(id) {
      this.item_id=id
      this.deleteModal=true
    },
    update(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var url = new URL(`${this.base_url}/BasicDefinitionsFiveF/update/${id}`);
      formdata.append('name', this.name)
      formdata.append('factor', this.factor)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
          if (response.message){
            toast.success(response.message)
            this.all()
            this.resetForm()
          }
          })
          .catch(error => console.error('Error:', error));
    },
    all() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var url = new URL(`${this.base_url}/BasicDefinitionsFiveF`);
      formdata.append('type', this.counter)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.data) {
              this.allItems = [...response.data]

            }
          })
          .catch(error => console.error('Error:', error));
    },
    resetForm() {
      this.name = ''
      this.factor = ''
      this.deleteModal = false
      this.is_update = false
      this.item_id = ''
    },

    nextPage() {
      if (this.counter === 3) {
        router.push('/5_f/step_2')
        return;
      };
      this.counter++
      this.nameRoute()
      this.all()
    }, backPage() {
      if (this.counter === 1) return false;

      this.counter--
      this.nameRoute()
      this.all()
    },
    nameRoute() {
      if (this.counter === 1) {
        this.name_route = 'دسته بندی بازارها'
      } else if (this.counter === 2) {
        this.name_route = 'دسته بندی مشتریان'
      } else if (this.counter === 3) {
        this.name_route = 'دسته بندی تامین کنندگان'
      }
      this.nameRoute2()

    },nameRoute2() {
      if (this.counter === 1) {
        this.name_route2 = 'بازار'
      } else if (this.counter === 2) {
        this.name_route2 = 'مشتری'
      } else if (this.counter === 3) {
        this.name_route2 = 'تامین کننده'
      }

    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return false;

      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.nameRoute()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

.card:not(:last-child) {
  height: 12vw;
}

.btn-submit-1 {
  width: 18vw !important;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/
p {
  font-size: 1vw;
}

</style>